module.exports = __webpack_public_path__ + "static/img/loading.6ff8efb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = F7NO
// module chunks = 1